export function useCurrencyFormatting() {
  const currencySymbols = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    JPY: '¥',
    CAD: 'CAD',
    DKK: 'kr',
    PLN: 'zł',
    SEK: 'kr',
    NOK: 'kr',
    AUD: 'AUD',
    MXN: 'MXN',
    BRL: 'BRL',
    TRY: '₺',
    SGD: 'SGD'
  };

  function getCurrencyIso(customerOrder) {
    if (!customerOrder) return null;
    if (customerOrder?.marketAccount?.id === 10000) {
      return customerOrder?.customerorderitems?.[0]?.currencyName;
    }

    return customerOrder?.marketAccount?.country?.currencyIso;
  }

  function formatOriginalCurrency(value, customerOrder) {
    if (!value) return null;
    if (!customerOrder) return null;

    const currencyIso = getCurrencyIso(customerOrder);

    if (!currencyIso || currencyIso === 'EUR') return null;

    const currencySymbol = currencySymbols[currencyIso] ?? currencyIso;
    const spacer = currencySymbol.length > 1 ? ' ' : '';

    return `(${Number.parseFloat(value).toFixed(2)}${spacer}${currencySymbol})`;
  }

  return {
    currencySymbols,
    getCurrencyIso,
    formatOriginalCurrency
  };
}